import { ActManagementForm } from 'shell/view-models/act-form';
import { ActType } from 'shell/constants/act-type';
import { AccordionDeath as DeathDataVM } from 'shell/view-models/accordion-death';
import { DateTime } from 'luxon';
import { SubjectData } from 'shell/models/person';
import { transformDeath } from './death-data';

export type AccordionDeathActAnpr05 = Omit<DeathDataVM, 'digital'> & ActManagementForm;

export const transformDeathActAnpr05 = (
  person: SubjectData
): AccordionDeathActAnpr05 | undefined => {
  const death = transformDeath(person);

  const isDigital = Boolean(person.datiDecesso?.attoEventoANPR?.attoANSC);

  const isPaper = Boolean(person.datiDecesso?.attoEventoANPR?.atto);

  const result = death
    ? {
        ...death,
        actType: isDigital
          ? ActType.AttoDigitale
          : isPaper
          ? ActType.AttoCartaceo
          : ActType.SenzaAtto,
        digital: isDigital
          ? {
              documentDate: person.datiDecesso?.attoEventoANPR?.attoANSC?.dataFormazioneAtto
                ? DateTime.fromISO(person.datiDecesso?.attoEventoANPR?.attoANSC?.dataFormazioneAtto)
                : null,
              idAnsc: person.datiDecesso?.attoEventoANPR?.attoANSC?.idANSC || '',
              istatCode:
                person.datiDecesso?.attoEventoANPR?.attoANSC?.comuneRegistrazione?.codiceIstat ||
                '',
              municipality: {
                id:
                  person.datiDecesso?.attoEventoANPR?.attoANSC?.comuneRegistrazione?.codiceIstat ||
                  '',
                description:
                  person.datiDecesso?.attoEventoANPR?.attoANSC?.comuneRegistrazione?.nomeComune ||
                  '',
                province:
                  person.datiDecesso?.attoEventoANPR?.attoANSC?.comuneRegistrazione
                    ?.siglaProvinciaIstat || '',
              },
              numberMunicipality:
                person.datiDecesso?.attoEventoANPR?.attoANSC?.numeroComunale || '',
              year: person.datiDecesso?.attoEventoANPR?.attoANSC?.anno || '',
              transcript:
                person.datiDecesso?.attoEventoANPR?.attoANSC?.trascritto === '1' ? true : false,
            }
          : undefined,
        paper: isPaper
          ? {
              // paper
              actMunicipality: person.datiDecesso?.attoEventoANPR?.atto?.comuneRegistrazione
                ? {
                    description:
                      person.datiDecesso?.attoEventoANPR?.atto?.comuneRegistrazione?.nomeComune ||
                      '',
                    province:
                      person.datiDecesso?.attoEventoANPR?.atto?.comuneRegistrazione
                        ?.siglaProvinciaIstat || '',
                    id:
                      person.datiDecesso?.attoEventoANPR?.atto?.comuneRegistrazione?.codiceIstat ||
                      '',
                  }
                : undefined,
              actYear: person.datiDecesso?.attoEventoANPR?.atto?.anno || '',
              actNumber: person.datiDecesso?.attoEventoANPR?.atto?.numeroAtto || '',
              actPart: person.datiDecesso?.attoEventoANPR?.atto?.parte || '',
              actSeries: person.datiDecesso?.attoEventoANPR?.atto?.serie || '',
              actVolume: person.datiDecesso?.attoEventoANPR?.atto?.volume || '',
              actDate: person.datiDecesso?.attoEventoANPR?.atto?.dataFormazioneAtto
                ? DateTime.fromISO(person.datiDecesso?.attoEventoANPR?.atto?.dataFormazioneAtto)
                : null,
              transcribed:
                person.datiDecesso?.attoEventoANPR?.atto?.trascritto === '1' ? true : false,
            }
          : undefined,
      }
    : undefined;

  return result;
};
